<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.divulgacao"
            sort-by="infraestruturaNome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.ModalExame.open(item)"
                    color="info"
                    small
                    title="Exames"
                >
                    <rkm-icon icon="dna" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalProcedimentoCirurgico.open(item)"
                    color="info"
                    small
                    title="Procedimentos cirúrgicos"
                >
                    <rkm-icon icon="pump-medical" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalEspecialidade.open(item)"
                    color="info"
                    small
                    title="Especialidades"
                >
                    <rkm-icon icon="book-medical" />
                </rkm-button>

                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :color="item.ativo ? 'dark' : 'success'"
                    :title="item.ativo ? 'Desativar' : 'Ativar'"
                    @click="item.ativo = !item.ativo"
                    small
                >
                    <rkm-icon :icon="item.ativo ? 'ban' : 'check-circle'" />
                </rkm-button>

                <rkm-button
                    :disabled="disableDestroy(item)"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />

        <ModalExame
            :data="data"
            ref="ModalExame"
        />

        <ModalProcedimentoCirurgico
            :data="data"
            ref="ModalProcedimentoCirurgico"
        />

        <ModalEspecialidade
            :data="data"
            ref="ModalEspecialidade"
        />
    </div>
</template>

<script>
// Components.
import Modal from './Modal'
import ModalExame from './components/exame/Modal'
import ModalProcedimentoCirurgico from './components/procedimento-cirurgico/Modal'
import ModalEspecialidade from './components/especialidade/Modal'

export default {
    components: { Modal, ModalExame, ModalProcedimentoCirurgico, ModalEspecialidade },
    data: () => ({
        fields: [
            { key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        disableDestroy(regulador) {

            return this.data.model.solicitantes
                .some(s => !!s.reguladores.find(r => r.infraestruturaId === regulador.infraestruturaId))
        },
        destroy(regulador) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir o regulador?',
                async () => this.data.model.reguladores.splice(this.data.model.reguladores.indexOf(regulador), 1)
            )
        }
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>